// RemittanceOffice Getters

export const getRemittanceOfficeList = state => {
  return state.remittanceOfficeList
}

export const getRemittanceOfficeInfo = state => {
  return state.remittanceOfficeInfo
}

export const getFullRemittanceOfficesList = state => {
  return state.fullRemittanceList
}
